import React, { useEffect, useState } from 'react';
import { v1 } from 'uuid';
import { minimalRoleRequired } from 'utils';
import { mainNav } from 'utils/const';
import useAuth from 'providers/Auth/useAuth';
import Item from 'components/MainNav/Item';
import logo from 'assets/images/logo_white.png';
import './mainNav.style.scss';
import Close from 'components/icons/Close';
import { SimulationContext } from 'components/pages/Exploitation/SimulationContext';
import LogoutIcon from '@mui/icons-material/Logout';
import { elementNotVisibleOnEnv } from 'utils';
import { Ribbon } from 'react-ribbons';
import doc from 'assets/images/doc.png';
import { StyledTooltip } from 'utils/Datagrid/CustomGenericDataGridUtils';
import { useTranslation } from 'react-i18next';
import LangSwitch from './LangSwitch';

const MainNav = ({ user }) => {
  const [active, setActive] = useState(3);
  const { logout } = useAuth();
  const [isRibbonVisible, setIsRibbonVisible] = useState(true);
  const env = process.env.REACT_APP_ENV;
  const { t } = useTranslation();

  window.addEventListener('setActiveMainNavBar', () => {
    setActive(1);
  });

  useEffect(() => {
    return () => window.removeEventListener('setActiveMainNavBar', null);
  }, []);

  useEffect(() => {
    const currentPath = window.location.pathname;
    setActive(mainNav.filter((x) => currentPath.match('/' + x.path))[0].id);
  }, []);

  const { setSimulationContext } = React.useContext(SimulationContext);

  const logoutApp = () => {
    setSimulationContext();
    logout();
  };

  //Function to get ribbon depending on environment
  const shouldDisplayRibbon = () => {
    const ribbonColors = {
      dev: '#E40230',
      preprod: '#b55103',
      test: 'black',
    };
    // If the environment is "prod", do not display the ribbon
    if (elementNotVisibleOnEnv.includes(env)) return null;

    // Use default "dev" color for unknown environments
    const ribbonColor = ribbonColors[env] || ribbonColors.dev;

    return (
      <Ribbon
        side="left"
        type="corner"
        size="large"
        backgroundColor={ribbonColor}
        color="#ccffff"
        fontFamily="rubik"
        withStripes={false}
      >
        {env + ' '}
        <Close className="ribbon-close" width={10} height={10} strokeWidth={4} />
      </Ribbon>
    );
  };

  return (
    <div className="mainNav">
      <div className="mainNav-contains">
        {isRibbonVisible && (
          <div
            className="ribbon"
            role="button"
            onClick={() => {
              setIsRibbonVisible(!isRibbonVisible);
            }}
          >
            {shouldDisplayRibbon()}
          </div>
        )}
        <div className="bar-box">
          <img src={logo} className="nav-logo" alt="logo assolia" />
        </div>
        <div className="items-contains">
          {mainNav.map(
            (e) =>
              minimalRoleRequired(user?.role, e.minimalRole) && (
                <Item
                  key={v1()}
                  id={e.id}
                  path={e.path}
                  text={e.text}
                  onChangePath={(id) => setActive(id)}
                  active={e.id === active}
                />
              ),
          )}
        </div>
        <StyledTooltip title={t('button.documentation')} placement="left">
          <a
            href="https://drive.google.com/drive/folders/102KdyraeEUYSMsygIaYK78W-5VwYK6Do?usp=sharing"
            target="_blank"
          >
            <div className="item no-padding">
              <img width={30} height={30} src={doc} alt="lien documentation assolia" />
            </div>
          </a>
        </StyledTooltip>
        <LangSwitch />
        <a onClick={() => logoutApp()}>
          <div className="item">
            <LogoutIcon className="logout-icon" />
          </div>
        </a>
      </div>
    </div>
  );
};

export default MainNav;
